<footer>
  <div
    class="mx-auto flex flex-col justify-center items-center justify-between h-full xl:h-8 py-4 xl:py-2 w-full xl:w-[58rem] xl:flex-row gap-4 bg-[--background-color] text-[10.5px] md:text-[13px] text-[--text-secondary-color]"
  >
    <span class="text-center font-bold"
      ><a href="https://www.acp-gruppe.com" target="_blank">© ACP Group AG {{year}}</a></span
    >
    <nav class="flex flex-wrap justify-center gap-x-8 xl:gap-x-16" aria-label="footer">
      <a href="https://www.acp-gruppe.com/kontakt?hsLang=de-at" target="_blank">{{ "footer.contact" | translate }}</a>
      <!-- <a href="https://www.acp-gruppe.com/tools?hsLang=de-at" target="_blank">{{ "footer.tools" | translate }}</a> -->
      <a href="https://www.acp-gruppe.com/impressum?hsLang=de-at" target="_blank">{{
        "footer.legalNotice" | translate
      }}</a>
      <a href="https://www.acp-gruppe.com/datenschutz?hsLang=de-at" target="_blank">{{
        "footer.dataPrivacy" | translate
      }}</a>
      <a href="https://www.acp-gruppe.com/agb?hsLang=de-at" target="_blank">{{ "footer.generalTerms" | translate }}</a>
      <a href="https://www.acp-gruppe.com/de/nutzungsbedingungen" target="_blank">{{ "footer.termsOfUse" | translate }}</a>
      <a [routerLink]="[routes.versionLogPath]">{{ "footer.version" | translate : {version:version} }}</a>
    </nav>
  </div>
</footer>
